export default ({ store, query }) => {
  const token = query.userId
  if (token) {
    store.commit('setAccessToken', token)
  }
}
